const postCodeFormat = (postcode: string | number) => {
    const postcodeString = String(postcode || '');
    if (postcodeString.length === 7) {
        const postcodeFirst = postcodeString.substr(0, 3);
        const postcodeLast = postcodeString.substr(3, 4);
        return (
            <>〒{postcodeFirst}-{postcodeLast}</>
        );
    }
    return (<>{postcodeString || ''}</>);
}

export default postCodeFormat;